import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FooterItem } from '../footer.component';
import { NavigationLink } from '@ebeihilfe/core';
import { RouterLink } from '@angular/router';
import { ToI18nKeyPipe } from './to-i18n-key/to-i18n-key.pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [RouterLink, ToI18nKeyPipe, TranslateModule],
  selector: 'portal-footer-list',
  templateUrl: './footer-list.component.html',
  styleUrls: ['./footer-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterListComponent {
  public groupedLinkList = input<FooterItem>();
  public NavigationLink: NavigationLink;
}
